import React from 'react';
import { priorityInfo } from '../../data/guide/statGuide';
import type { StatPriority } from '../../types/classBuild';
export function PriorityBadge({
  p,
  className = ''
}: {
  p: StatPriority;
  className?: string;
}) {
  const info = priorityInfo[p];
  return <span className={`inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-semibold ${info.tone} ${className}`} data-id="element-385" data-mp="10fxrzpenl8wn">{info.label}</span>;
}